<template>
<!-- Swiper -->
<div class="rew18_main-banner aro">

  <!-- rew18_slideMb_wrap-->
  <div class="rew18_slideMb_wrap">
    <div class="swiper-container rew18_slide_mb">
      <div class="swiper-wrapper">
<!--        <div class="swiper-slide meta">-->
<!--          <a href="/app/ro/aroShop/smartBeautyIntroduce">-->
<!--            <img src="https://resource2018.nuskinkorea.co.kr/images/aro/banner_07_m.jpg" alt="">-->
<!--            <div class="rew19_slideContents black">-->
<!--              <span class="title_sub">SMART BEAUTY</span>-->
<!--              <h2 class="title_main">누구나 부담없이 시작할 수 있는 스마트 뷰티 멤버십</h2>-->
<!--              <button class="btn_detail">자세히보기</button>-->
<!--            </div>-->
<!--          </a>-->
<!--        </div>-->
        <div class="swiper-slide">
          <a @click="openIntroAroDialog">
            <img src="https://resource2018.nuskinkorea.co.kr/images/aro/banner_05_m.jpg" alt="">
            <div class="rew19_slideContents white">
              <span class="title_sub">정기구매</span>
              <h2 class="title_main">매월 할인된 가격으로, 원하는 날짜와 장소에서</h2>
              <button class="btn_detail">자세히보기</button>
            </div>
          </a>
        </div>
<!--        <div class="swiper-slide">
          <a href="/app/ro/aroShop/fourplusIntroduce01">
            <img src="https://resource2018.nuskinkorea.co.kr/images/aro/banner_03_m.png" alt="">
            <div class="rew19_slideContents black">
              <span class="title_sub">정기구매 전용</span>
              <h2 class="title_main">에이지락 스마트 뷰티 4+1 프로그램</h2>
              <button class="btn_detail">자세히보기</button>
            </div>
          </a>
        </div>-->
<!--        <div class="swiper-slide">-->
<!--          <a href="/app/ro/aroShop/fifteenthIntroduce">-->
<!--            <img src="https://resource2018.nuskinkorea.co.kr/images/aro/15banner_01_mb.jpg" alt="">-->
<!--            <div class="rew19_slideContents black" style="width: 100%;">-->
<!--              <span class="title_sub">5월 한정 사은품 증정</span>-->
<!--              <h2 class="title_main">유스스팬3/메타/알-스퀘어드<br /> 15% 약정 정기구매</h2>-->
<!--              <button class="btn_detail">자세히보기</button>-->
<!--            </div>-->
<!--          </a>-->
<!--        </div>-->
<!--        <div class="swiper-slide">
          <a href="javascript:;">
            <img src="https://resource2018.nuskinkorea.co.kr/images/aro/banner_06_m.jpg" alt="">
            <div class="rew19_slideContents purple">
              <span class="title_sub">파마넥스 정기구매</span>
              <h2 class="title_main">에이지락 메타 약정 정기구매<br/>자세히 보기</h2>
              <button class="btn_detail double" @click="goUrl('/app/board/cr/CustNoticeDetail?boardSeq=224096&boardWkCd=041&page=1')">15% 약정<p>(2022.03)</p></button>
              <button class="btn_detail2 double" @click="goUrl('https://resource2018.nuskinkorea.co.kr/upload/20230327/ageloc_meta_10P_promotion.pdf')">10% 약정<p>(2023.04)</p></button>
            </div>
          </a>
        </div>-->

        <div class="swiper-slide">
          <a href="/app/ro/aroShop/nourishIntroduce">
            <img src="https://resource2018.nuskinkorea.co.kr/images/aro/banner_02_m.png" alt="">
            <div class="rew19_slideContents black">
              <span class="title_sub">함께 동참해주세요</span>
              <h2 class="title_main"><p>너리시 더 칠드런</p></h2>
              <button class="btn_detail">자세히보기</button>
            </div>
          </a>
        </div>

      </div>
      <div class="swiper-scrollbar rew18_slideMb_scrollbar"></div>
    </div><!--//rew18_slide_mb-->
  </div>
  <!--//rew18_slideMb_wrap-->

  <!-- rew18_slidePc_wrap-->
  <div class="rew18_slide_wrap">
    <div class="swiper-container rew18_slide_pc">
      <div class="swiper-wrapper">

        <div class="swiper-slide" style="background-image: url('https://resource2018.nuskinkorea.co.kr/images/aro/banner_02.png')">
          <a href="/app/ro/aroShop/nourishIntroduce" class="rew19_fullLink">
            <div class="rew19_slideContents black">
              <span class="title_sub">함께 동참해주세요</span>
              <h2 class="title_main"><p>너리시 더 칠드런</p></h2>
              <button class="btn_detail">자세히보기</button>
            </div>
          </a>
        </div>

<!--        <div class="swiper-slide" style="background-image: url('https://resource2018.nuskinkorea.co.kr/images/aro/banner_07_pc.jpg')">-->
<!--          <a href="/app/ro/aroShop/smartBeautyIntroduce" class="rew19_fullLink" style="height: 90%;">-->
<!--            <div class="rew19_slideContents black">-->
<!--              <span class="title_sub">SMART BEAUTY</span>-->
<!--              <h2 class="title_main">누구나 부담없이 시작할 수 있는<br/>스마트 뷰티 멤버십</h2>-->
<!--              <p style="color: #303030; font-size: 20px; margin-bottom: 10px;">2024년 3월 8일 오전 11시~</p>-->
<!--              <button class="btn_detail">자세히보기</button>-->
<!--            </div>-->
<!--          </a>-->
<!--        </div>-->

        <div class="swiper-slide" style="background-image: url('https://resource2018.nuskinkorea.co.kr/images/aro/banner_05_pc.jpg')">
          <a @click="openIntroAroDialog" class="rew19_fullLink">
            <div class="rew19_slideContents white">
              <span class="title_sub">정기구매</span>
              <h2 class="title_main">매월 할인된 가격으로,<br/>원하는 날짜와 장소에서</h2>
              <button class="btn_detail">자세히보기</button>
            </div>
          </a>
        </div>
<!--        <div class="swiper-slide" style="background-image: url('https://resource2018.nuskinkorea.co.kr/images/aro/banner_03.png')">
          <a href="/app/ro/aroShop/fourplusIntroduce01" class="rew19_fullLink">
            <div class="rew19_slideContents black">
              <span class="title_sub">정기구매 전용</span>
              <h2 class="title_main">에이지락 스마트 뷰티<br/>4+1 프로그램</h2>
              <button class="btn_detail">자세히보기</button>
            </div>
          </a>
        </div>-->
<!--        <div class="swiper-slide" style="background-image: url('https://resource2018.nuskinkorea.co.kr/images/aro/15banner_01.jpg')">-->
<!--          <a href="/app/ro/aroShop/fifteenthIntroduce" class="rew19_fullLink">-->
<!--            <div class="rew19_slideContents black" style="padding-top: 130px;">-->
<!--              <span class="title_sub">5월 한정 사은품 증정</span>-->
<!--              <h2 class="title_main">유스스팬3/메타/알-스퀘어드<br /> 15% 약정 정기구매</h2>-->
<!--              <p style="color: #808080; font-size: 20px; margin-bottom: 20px;">2024년 5월 1일(수)~</p>-->
<!--              <button class="btn_detail">자세히보기</button>-->
<!--            </div>-->
<!--          </a>-->
<!--        </div>-->

<!--        <div class="swiper-slide" style="background-image: url('https://resource2018.nuskinkorea.co.kr/images/aro/banner_06.jpg')">
          <a href="javascript:;">
            <div class="rew19_slideContents purple">
              <span class="title_sub">파마넥스 정기구매</span>
              <h2 class="title_main">에이지락 메타 약정 정기구매<br/>자세히 보기</h2>
              <button class="btn_detail double" @click="goUrl('/app/board/cr/CustNoticeDetail?boardSeq=224096&boardWkCd=041&page=1')">15% 약정<p>(2022.03)</p></button>
              <button class="btn_detail2 double" @click="goUrl('https://resource2018.nuskinkorea.co.kr/upload/20230327/ageloc_meta_10P_promotion.pdf')">10% 약정<p>(2023.04)</p></button>
            </div>
          </a>
        </div>-->

      </div>
      <div class="swiper-scrollbar rew18_slide_scrollbar"></div>
      <div class="rew18_slide_btnNext"></div>
      <div class="rew18_slide_btnPrev"></div>
    </div><!--//rew18_slide_pc-->
  </div><!--//rew18_slide_wrap-->

  <intro-aro-dialog
    ref="introAddDialog"
    :show="introAddDialogShow"
    @close='onCloseIntroAroDialog'></intro-aro-dialog>

</div>
<!--//rew18_main_banner-->
</template>
<script>
import AroBase from '@/components/base/AroBase';
import IntroAroDialog from '@/components/popup/IntroAroDialog';
export default {
  name: 'AroMainBanner',
  extends: AroBase,
  components: { IntroAroDialog },
  props: {},
  data() {
    return {
      introAddDialogShow : false,
    }
  },
  mounted() {
    let _this = this;

    _this.remove15perDate();
  },
  methods :{
    openIntroAroDialog(){
       let _this = this;
      _this.introAddDialogShow = true;
    },
    onCloseIntroAroDialog(isOk, data){
      let _this = this;
      _this.introAddDialogShow = false;

      if(!isOk){
        //Do nothing.
        return;
      }
    },
    //target 날짜 기준 15퍼 카테고리 제거
    apiRemove15perDate() {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/remove15perCategory`, {
        params: {}
      });
    },
    goUrl(url){
      location.href=url;
      return false;
    },
    remove15perDate(){
      let _this = this;

      _this.apiRemove15perDate().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          if(res.data.result){
            // if(res.data.isRemove15per == 'N'){
            //   let meta = document.getElementsByClassName("meta");
            //   let wrap = document.getElementsByClassName("swiper-wrapper");
            //   for(let i=0; i<wrap.length; i++){
            //     wrap[i].insertBefore(meta[i], wrap[i].firstChild);
            //   }
            // }else{
            //   let buyBtn = document.getElementsByClassName("metaBuy");
            //   for(let i=0; i<buyBtn.length; i++){
            //     buyBtn[i].style.display = "none";
            //   }
            // }
            _this.$showProductBanner();
          }
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },
  }
}
</script>
<style>
a.rew19_openPop, a.rew19_fullLink {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/banner/AroMainBanner.vue